import loadable from '../../shared/utils/loadable';

// Code splitting!

const EnrollmentsApp = loadable(() => import('../App'));

const Dashboard = loadable(() => import('../containers/Dashboard'));

const routes = [
	{
		path: '/dashboard',
		component: EnrollmentsApp,
		routes: [{
			path: '/dashboard',
			exact: true,
			component: Dashboard,
		}],
	},
	// NOTE: deprecated routes
	{
		path: '/enrollments',
		component: EnrollmentsApp,
		routes: [{
			path: '/enrollments/pending',
			component: Dashboard
		}, {
			path: '/enrollments',
			exact: true,
			component: Dashboard
		}]
	}
];

export default routes;
